import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  loaderWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexShrink: 0,
    flexGrow: 1,
  },

  loaderWrap: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

export default styles;
